const GetDaysInYears = (year) => {
  if (year) {
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) return 366;
    return 365;
  }
};

export default GetDaysInYears;
